import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { LavaLand_ResponsivePIXIApp } from "../LavaLand/game_ResponsivePIXIApp";

    export class LavaLandLink_ResponsivePIXIApp extends LavaLand_ResponsivePIXIApp {      
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "LavaLandLink");
       }

    }